import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import permissionsReducer from './permissionsSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    permissions: permissionsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['persist/PERSIST'],
      },
    }),
}); 